import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import * as soundStereo from "./components/sound-stereo";
import * as sound51 from "./components/sound-51";
import * as sound514 from "./components/sound-514";
import * as sound714 from "./components/sound-714";

const principle: Slide = {
  description:
    "Different speaker setups have been recorded with an artificial head. Use the menu to choose a configuration among 2.0, 5.1, 5.1.4 and 7.1.4 then press the play button. The listening must be done with headphones to recreate the best possible spatialization of the sound. Many thanks to Dolby for the sound recording, images have been adapted from Dolby’s drawings.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          options: {},
          items: [{ name: "Stereo" }, { name: "5.1" }, { name: "5.1.4" }, { name: "7.1.4" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [soundStereo.extraContent, sound51.extraContent, sound514.extraContent, sound714.extraContent],
      components: [soundStereo.components, sound51.components, sound514.components, sound714.components],
    },
  },
};

export default principle;
